import { PureComponent } from 'preact-compat'
import { toggleClosed } from '@insided/shared/services/topicService'
import { ContentType } from '@insided/shared/utils/contentType'
// eslint-disable-next-line import/no-internal-modules
import Switcher from '@insided/deprecated-preact-components/control/Switcher'

interface OptionsProps {
  onClosedChanged: (closed: boolean) => void
  setIsLoading: (isLoading: boolean) => void
  closed: boolean
  contentType: ContentType
  privateId: number
}

class Options extends PureComponent<OptionsProps> {
  constructor (props: OptionsProps) {
    super(props)
    this.onChangeClosed = this.onChangeClosed.bind(this)
  }

  async onChangeClosed () {
    const { closed, setIsLoading, onClosedChanged, contentType, privateId } = this.props
    const newClosed = !closed
    try {
      await toggleClosed(contentType, privateId, newClosed)
      onClosedChanged(newClosed)
    } finally {
      setIsLoading(false)
    }
  }

  render () {
    const { closed } = this.props
    return (
      <div className='topic-info__details-item'>
        <label>Options</label>
        <div>
          <Switcher
            on={closed}
            onChange={this.onChangeClosed}
            label='Close topic'
          />
        </div>
      </div>
    )
  }
}

export default Options
